import React, { useState, useEffect } from "react";
import DomainModal from "./DomainModal";
import DetailsModal from "./DetailsModal";
import { userinfo, actions, addanew ,adddomain} from "../apis/services";
import CircularLoader from "./CircularLoader"; // Import the loader
import Swal from 'sweetalert2';

const MyApp = ({ translate }) => {
  const [apps, setApps] = useState([]);
  const [showDomainModal, setShowDomainModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedAppIndex, setSelectedAppIndex] = useState(null);
  const [loading, setLoading] = useState(true);

  const token = {
    token: localStorage.getItem("token"),
  };

  useEffect(() => {
    setLoading(true); // Ensure loading is set before fetching
    userinfo(token)
      .then((response) => {
        console.log("API response:", response);
        setApps(response.panel);
      })
      .catch((error) => {
        console.error("Error fetching user info:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const addApp = async (event) => {
    event.preventDefault();
    setLoading(true); // Start the loading spinner

    const appName = event.target.appName.value;
    const kind = event.target.kind.value;

    if (appName && kind) {
      try {
        await add_servis(appName, kind); // Wait for the service to be added
        setLoading(false); // Once the service is added, stop the loader
        event.target.reset();
      } catch (error) {
        console.error("Error adding service:", error);
        setLoading(false); // Stop the loader if there's an error
      }
    } else {
      alert(translate("pleaseEnterAppName"));
      setLoading(false); // Stop loading in case of validation failure
    }
  };

  const add_servis = (cname, kind) => {
    const updatedApps = [...apps];
    const token = localStorage.getItem("token");

    const services = {
      1: { data: { token, containerName: cname, rootPassword: `${cname}_root` }, path: "install-mysql" },
      2: { data: { token, containerName: cname, vncPassword: `${cname}_root` }, path: "install-ubunto" },
      3: { data: { token, containerName: cname, password: `${cname}_root` }, path: "install-mongodb" },
      4: { data: { token, containerName: cname }, path: "install-wordpress" },
      5: { data: { token, containerName: cname, saPassword: `${cname}_root` }, path: "install-mssql" },
      6: { data: { token, containerName: cname, postgresPassword: `${cname}_root` }, path: "install-postegres" },
    };

    const selectedService = services[kind];
    if (!selectedService) {
      console.error("Invalid service type!");
      return Promise.reject("Invalid service type!");
    }

    const { data: add, path } = selectedService;

    return addanew(add, path).then((response) => {
      console.log("Service added:", response);
      Swal.fire({
        title: 'سرویس با موفقیت اضافه شد',
        text:  response.message,
        confirmButtonText: 'متوجه شدم',
      });
      setApps(updatedApps);
      return response;
    }).catch((error) => {
      console.error("Error adding service:", error);
      if (error.response && error.response.status === 402) {
        Swal.fire({
          title: ' اعتبار کافی نیست' || error.message,
          text: translate("insufficientFunds") || "موجودی حساب شما کافی نیست یا ایمبل خود را تایید نکرده اید !" || error.message,
          confirmButtonText: 'متوجه شدم',
        });
      } else {
        Swal.fire({
          title: ' اعتبار کافی نیست' || error.message,
          text: translate("errorAddingService") || " موجودی حساب شما کافی نیست یا ایمیل شما تایید نشده" || error.message,
          confirmButtonText: 'متوجه شدم',
        });
      }
      throw error;
    });
  };
  
  const runApp = (index) => {
    const updatedApps = [...apps];
    updatedApps[index].status = translate("running");
    const stop = {
      token: localStorage.getItem("token"),
      containerName: updatedApps[index].container_name,
      action: "start",
    };
    actions(stop).then((response) => {
      console.log(response);
      Swal.fire({
        title: ' (برای سرویس ساعتی در دست رس است)سرویس روشن شد',
        text: translate("serviceStarted") || "Service started successfully",
        confirmButtonText: 'متوجه شدم',
      });
    }).catch(error => {
      Swal.fire({
        title: 'خطا',
        text: translate("errorStartingService") || "Error starting service",
        confirmButtonText: 'متوجه شدم',
      });
    });
    setApps(updatedApps);
  };

  const stopApp = (index) => {
    const updatedApps = [...apps];
    updatedApps[index].status = translate("stopped");
    const stop = {
      token: localStorage.getItem("token"),
      containerName: updatedApps[index].container_name,
      action: "stop",
    };
    actions(stop).then((response) => {
      console.log(response);
      Swal.fire({
        title: '(برای سرویس ساعتی در دسترس است)سرویس خاموش شد',
        text: translate("serviceStopped") || "Service stopped successfully",
        confirmButtonText: 'متوجه شدم',
      });
    }).catch(error => {
      Swal.fire({
        title: 'خطا',
        text: translate("errorStoppingService") || "Error stopping service",
        confirmButtonText: 'متوجه شدم',
      });
    });
    setApps(updatedApps);
  };

  const deleteApp = (index) => {
    const updatedApps = apps.filter((_, i) => i !== index);
    Swal.fire({
      title: '(برای سرویس ساعتی در دسترس است)سرویس حذف شد',
      text: translate("serviceStopped") || "Service stopped successfully",
      confirmButtonText: 'متوجه شدم',
    });
    setApps(updatedApps);

  };

  const openDomainModal = (index) => {
    setSelectedAppIndex(index);
    setShowDomainModal(true);
  };

  const openDetailsModal = (index) => {
    setSelectedAppIndex(index);
    setShowDetailsModal(true);
  };

  const saveDomain = (domainName,port) => {
    const domaindata ={
      token : localStorage.getItem("token"),
      domain : domainName,
      port : port
    }
    adddomain(domaindata).then((response) => {
      console.log(response);
      Swal.fire({
        title: 'دامنه با موفقیت اضافه شد',
        text: translate("serviceAddedSuccess") || response.message,
        confirmButtonText: 'متوجه شدم',
      });
      const updatedApps = [...apps];
      updatedApps[selectedAppIndex].domain = domainName;
      setApps(updatedApps);
      setShowDomainModal(false);
    }).catch((error) => {
      console.error("Error adding domain:", error);  
      Swal.fire({
        title: 'Error adding domain',
        text: translate("serviceAddedSuccess") || error.message,
        confirmButtonText: 'متوجه شدم',
      }); 
    }
    );
  };

  return (
    <div>
      {loading ? (
        <CircularLoader />
      ) : (
        <>
        
          <h2>{translate("welcome")}</h2>
          <div className="form-container">
            <form onSubmit={addApp}>
              <input type="text" name="appName" placeholder={translate("appName")} required />
              <br />
              <select type="text" name="kind" required>
                <option value="4">Wordpress</option>
                <option value="1">MYSQL</option>
                <option value="5">MSSQL</option>
                <option value="3">MongoDB</option>
                <option value="2">Trid Server</option>
                <option value="6">Vitagir Crm</option>
              </select>
              <button type="submit">{translate("addApp")}</button>
            </form>
          </div>

          <div className="app-list">
            <table>
              <thead>
                <tr>
                  <th>{translate("appName")}</th>
                  <th>{translate("status")}</th>
                  <th>{translate("domain")}</th>
                  <th>{translate("ns")}</th>
                  <th>{translate("actions")}</th>
                </tr>
              </thead>
              <tbody>
                {apps.map((app, index) => (
                  <tr key={index}>
                    <td>{app.container_name}</td>
                    <td>{app.status || "-"}</td>
                    <td>{app.domain || "-"}</td>
                    <td>{app.ns || "-"}</td>
                    <td>
                      <button className="run" onClick={() => runApp(index)}>
                        {translate("run")}
                      </button>
                      <button className="stop" onClick={() => stopApp(index)}>
                        {translate("stop")}
                      </button>
                      <button className="domain" onClick={() => openDomainModal(index)}>
                        {translate("domain")}
                      </button>
                      <button className="details" onClick={() => openDetailsModal(index)}>
                        {translate("showDetails")}
                      </button>
                      <button className="delete" onClick={() => deleteApp(index)}>
                        {translate("delete")}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {showDomainModal && (
            <DomainModal
              translate={translate}
              app={apps[selectedAppIndex]}
              onSave={saveDomain}
              onClose={() => setShowDomainModal(false)}
            />
          )}

          {showDetailsModal && (
            <DetailsModal
              translate={translate}
              app={apps[selectedAppIndex]}
              onClose={() => setShowDetailsModal(false)}
            />
          )}
        </>
      )}
    </div>
  );
};

export default MyApp;
